/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ptl-v3-magic-link-form',
  templateUrl: './v3-magic-link-form.component.html',
  styleUrls: ['./v3-magic-link-form.component.scss'],
})
export class V3MagicLinkFormComponent {
  @Input() email: string;
  @Input() magicLinkSent = false;
  @Input() magicLinkRequestInProgress = false;

  @Output() requestLink = new EventEmitter<void>();
  @Output() backToSignIn = new EventEmitter<void>();
}
